<template>
  <div class="header header-one">
    <router-link
      to="/"
      class="d-inline-flex d-sm-inline-flex align-items-center d-md-inline-flex d-lg-none align-items-center device-logo"
    >
      <img src="@/assets/img/logo.png" class="img-fluid logo2" alt="Logo" />
    </router-link>
    <div
      class="main-logo d-inline float-start d-lg-flex align-items-center d-none d-sm-none d-md-none"
    >
      <div class="logo-white">
        <router-link to="/">
          <img
            src="@/assets/img/logo-full-white.png"
            class="img-fluid logo-blue"
            alt="Logo"
          />
        </router-link>
        <router-link to="/">
          <img
            src="@/assets/img/logo-small-white.png"
            class="img-fluid logo-small"
            alt="Logo"
          />
        </router-link>
      </div>
      <div class="logo-color">
        <router-link to="/">
          <img src="@/assets/img/logo.png" class="img-fluid logo-blue" alt="Logo" />
        </router-link>
        <router-link to="/">
          <img
            src="@/assets/img/logo-small.png"
            class="img-fluid logo-small"
            alt="Logo"
          />
        </router-link>
      </div>
    </div>

    <!-- Sidebar Toggle -->
    <a href="javascript:void(0);" id="toggle_btn" @click="toggleSidebar">
      <span class="toggle-bars">
        <span class="bar-icons"></span>
        <span class="bar-icons"></span>
        <span class="bar-icons"></span>
        <span class="bar-icons"></span>
      </span>
    </a>
    <!-- /Sidebar Toggle -->


    <!-- Mobile Menu Toggle -->
    <a class="mobile_btn" id="mobile_btn" @click="toggleSidebar1">
      <i class="fas fa-bars"></i>
    </a>
    <!-- /Mobile Menu Toggle -->

    <!-- Header Menu -->
    <ul class="nav nav-tabs user-menu">
     

      <!-- <li class="nav-item has-arrow dropdown-heads">
        <a href="javascript:void(0);" class="toggle-switch">
          <i class="feather feather-moon"></i>
        </a>
      </li> -->
      <li class="nav-item dropdown flag-nav dropdown-heads">
        <a class="nav-link" data-bs-toggle="dropdown" href="javascript:;" role="button">
          <i
            class="feather feather-bell d-flex align-items-center justify-content-center"
          ></i>
          <span class="badge rounded-pill"></span>
        </a>
        <div class="dropdown-menu notifications">
          <div class="topnav-dropdown-header">
            <div class="notification-title">
              Notifications <router-link to="/">View all</router-link>
            </div>
            <a href="javascript:void(0)" class="clear-noti d-flex align-items-center"
              >Mark all as read <i class="feather feather-check-circle"></i
            ></a>
          </div>
          <div class="noti-content">
            <ul class="notification-list">
              <li class="notification-message">
                <router-link to="/">
                  <div class="d-flex">
                    <span class="avatar avatar-md active">
                      <img
                        class="avatar-img rounded-circle"
                        alt="avatar-img"
                        src="@/assets/img/profiles/avatar-02.jpg"
                      />
                    </span>
                    <div class="media-body">
                      <p class="noti-details">
                        <span class="noti-title">Lex Murphy</span> requested access to
                        <span class="noti-title">UNIX directory tree hierarchy</span>
                      </p>
                      <div class="notification-btn">
                        <span class="btn btn-primary">Accept</span>
                        <span class="btn btn-outline-primary">Reject</span>
                      </div>
                      <p class="noti-time">
                        <span class="notification-time">Today at 9:42 AM</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="/">
                  <div class="d-flex">
                    <span class="avatar avatar-md active">
                      <img
                        class="avatar-img rounded-circle"
                        alt="avatar-img"
                        src="@/assets/img/profiles/avatar-10.jpg"
                      />
                    </span>
                    <div class="media-body">
                      <p class="noti-details">
                        <span class="noti-title">Ray Arnold</span> left 6 comments
                        <span class="noti-title"
                          >on Isla Nublar SOC2 compliance report</span
                        >
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">Yesterday at 11:42 PM</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="/">
                  <div class="d-flex">
                    <span class="avatar avatar-md">
                      <img
                        class="avatar-img rounded-circle"
                        alt="avatar-img"
                        src="@/assets/img/profiles/avatar-13.jpg"
                      />
                    </span>
                    <div class="media-body">
                      <p class="noti-details">
                        <span class="noti-title">Dennis Nedry</span> commented on
                        <span class="noti-title">
                          Isla Nublar SOC2 compliance report</span
                        >
                      </p>
                      <blockquote>
                        “Oh, I finished de-bugging the phones, but the system's compiling
                        for eighteen minutes, or twenty. So, some minor systems may go on
                        and off for a while.”
                      </blockquote>
                      <p class="noti-time">
                        <span class="notification-time">Yesterday at 5:42 PM</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="/">
                  <div class="d-flex">
                    <span class="avatar avatar-md">
                      <img
                        class="avatar-img rounded-circle"
                        alt="avatar-img"
                        src="@/assets/img/profiles/avatar-05.jpg"
                      />
                    </span>
                    <div class="media-body">
                      <p class="noti-details">
                        <span class="noti-title">John Hammond</span> created
                        <span class="noti-title">Isla Nublar SOC2 compliance report</span>
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">Last Wednesday at 11:15 AM</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="topnav-dropdown-footer">
            <a href="javascript:;">Clear All</a>
          </div>
        </div>
      </li>
      <li class="nav-item has-arrow dropdown-heads">
        <a href="javascript:void(0);" class="win-maximize" @click="initFullScreen">
          <i
            class="feather feather-maximize d-flex align-items-center justify-content-center"
          ></i>
        </a>
      </li>
      <!-- User Menu -->
      <li class="nav-item dropdown">
        <a href="javascript:void(0)" class="user-link nav-link" data-bs-toggle="dropdown">
          <span class="user-img">
            <img
              src="@/assets/img/profiles/avatar-07.jpg"
              alt="img"
              class="profilesidebar"
            />
            <span class="animate-circle"></span>
          </span>
          <span class="user-content">
            <span class="user-details">Admin</span>
            <span class="user-name">John Smith</span>
          </span>
        </a>
        <div class="dropdown-menu menu-drop-user">
          <div class="profilemenu">
            <div class="subscription-menu">
              <ul>
                <li>
                  <router-link class="dropdown-item" to="/perfil">Perfil</router-link>
                </li>
              </ul>
            </div>
            <div class="subscription-logout">
              <ul>
                <li class="pb-0">
                  <a class="dropdown-item" href="#" @click.prevent="logout">Cerrar Sesión</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </li>
      <!-- /User Menu -->
    </ul>

    <!-- /Header Menu -->
  </div>

  <side-settings></side-settings>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    // Add click event listener
    this.$nextTick(() => {
      document.addEventListener("click", this.handleToggleClick);
    });

    // Add mouseover event listener
    document.addEventListener("mouseover", (event) => {
      event.stopPropagation();

      var body = document.body;
      var toggleBtn = document.getElementById("toggle_btn");
      // var sidebar = document.getElementsByClassName("sidebar")[0];
      var subdropUL = document.getElementsByClassName("subdrop");

      if (body.classList.contains("mini-sidebar") && toggleBtn.style.display !== "none") {
        var target = event.target.closest(".sidebar");

        if (target) {
          body.classList.add("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "block";
            }
          }
        } else {
          body.classList.remove("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "none";
            }
          }
        }

        event.preventDefault();
      }
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleToggleClick);
  },

  methods: {
    toggleSidebar1() {
      const body = document.body;
      body.classList.toggle("slide-nav");
    },
    toggleSidebar() {
      const body = document.body;
      body.classList.toggle("mini-sidebar");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    logout() {
    try {
      // 1. Borrar los datos de autenticación del localStorage
      localStorage.removeItem('credentials');

      // (Opcional) Si manejas un estado global como Vuex o Pinia, aquí lo reiniciarías:
      // this.authStore.clear(); 

      // 2. Redirigir al usuario a la página de Login o Home
      this.$router.push('/login'); 
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  }
  },
};
</script>
